import { variables } from '../common/variables';

import { cl } from '../common/functions';

import { makeMarkerIcon } from './leaflet/markerIcon';

const geolocation = (map, group) => {
  const leafletControlContainer = document.querySelector('.leaflet-top.leaflet-left');
  if (leafletControlContainer) {
    const geolocationElement = `<div class="leaflet-control-geolocation leaflet-bar leaflet-control">
    <a class="leaflet-control-geolocation-button leaflet-bar-part"></a>
    </div>`;
    leafletControlContainer.insertAdjacentHTML('beforeend', geolocationElement);
    const geolocationButton = document.querySelector('.leaflet-control-geolocation-button');
    if (geolocationButton) {
      // prettier-ignore
      geolocationButton.addEventListener('click', () => {
        //geolocalisation
        navigator.geolocation.getCurrentPosition(location => {
          const marker = L.marker([location.coords.latitude, location.coords.longitude], {
            icon: makeMarkerIcon(null, null, "#42ace8", "user", null)
          });
          marker.addTo(map);
          marker.addTo(group);
          map.fitBounds(group.getBounds().pad(0.1));
        });
      }, false);
    }
  }
};

export { geolocation };
